import { colors } from "./colors";

export function ArrowDown({ color = colors.mainBg, style }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M18.6214 5.77097C18.7088 5.68441 18.8117 5.61675 18.9242 5.57183C19.0366 5.52691 19.1564 5.50563 19.2767 5.50919C19.397 5.51276 19.5154 5.5411 19.6252 5.5926C19.7351 5.6441 19.8341 5.71775 19.9168 5.80935C19.9994 5.90095 20.064 6.0087 20.1069 6.12644C20.1498 6.24419 20.1702 6.36964 20.1667 6.49561C20.1633 6.62158 20.1363 6.74562 20.0871 6.86065C20.0379 6.97567 19.9676 7.07942 19.8801 7.16598L11.635 15.3211C11.4649 15.4895 11.2397 15.5833 11.0056 15.5833C10.7715 15.5833 10.5463 15.4895 10.3762 15.3211L2.13014 7.16598C2.04076 7.07999 1.96858 6.97626 1.91781 6.86082C1.86703 6.74537 1.83867 6.62051 1.83436 6.49349C1.83005 6.36647 1.84988 6.23981 1.89271 6.12089C1.93553 6.00196 2.00049 5.89313 2.08382 5.80072C2.16714 5.7083 2.26717 5.63415 2.3781 5.58257C2.48902 5.53098 2.60862 5.50299 2.72996 5.50023C2.8513 5.49746 2.97195 5.51997 3.08492 5.56645C3.19788 5.61293 3.30089 5.68245 3.38798 5.77097L11.0056 13.3044L18.6214 5.77097Z"
        fill={color}
      />
    </svg>
  );
}

export function ArrowUp({ color = colors.mainBg, style }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M18.6213 16.229C18.7087 16.3156 18.8116 16.3833 18.924 16.4282C19.0365 16.4731 19.1563 16.4944 19.2765 16.4908C19.3968 16.4872 19.5153 16.4589 19.6251 16.4074C19.7349 16.3559 19.834 16.2822 19.9167 16.1907C19.9993 16.0991 20.0639 15.9913 20.1068 15.8736C20.1497 15.7558 20.17 15.6304 20.1666 15.5044C20.1632 15.3784 20.1362 15.2544 20.087 15.1394C20.0378 15.0243 19.9675 14.9206 19.88 14.834L11.6349 6.67892C11.4648 6.51051 11.2396 6.41667 11.0055 6.41667C10.7714 6.41667 10.5462 6.51051 10.3761 6.67892L2.13001 14.834C2.04064 14.92 1.96846 15.0237 1.91769 15.1392C1.86691 15.2546 1.83854 15.3795 1.83423 15.5065C1.82993 15.6335 1.84976 15.7602 1.89258 15.8791C1.93541 15.998 2.00037 16.1069 2.0837 16.1993C2.16702 16.2917 2.26705 16.3658 2.37798 16.4174C2.4889 16.469 2.6085 16.497 2.72984 16.4998C2.85118 16.5025 2.97183 16.48 3.08479 16.4336C3.19775 16.3871 3.30077 16.3176 3.38786 16.229L11.0055 8.69563L18.6213 16.229Z"
        fill={color}
      />
    </svg>
  );
}

export function SavedIcon({
  width = 19,
  height = 24,
  color = colors.blue,
  className = "active-listings-house-card-heard-list-saved active-listings-house-card-heard-list-opened",
}) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 19 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={className}
        d="M12.915 0C16.0767 0 18.6317 1.24833 18.6667 4.42167V22.1317C18.6667 22.33 18.62 22.5283 18.5267 22.7033C18.375 22.9833 18.1183 23.1933 17.8033 23.2867C17.5 23.38 17.1617 23.3333 16.8817 23.17L9.32167 19.39L1.75 23.17C1.57617 23.2622 1.37667 23.3217 1.17833 23.3217C0.525 23.3217 0 22.785 0 22.1317V4.42167C0 1.24833 2.56667 0 5.71667 0H12.915ZM13.7083 7.04667H4.92333C4.42167 7.04667 4.01333 7.455 4.01333 7.96833C4.01333 8.4805 4.42167 8.89 4.92333 8.89H13.7083C14.21 8.89 14.6183 8.4805 14.6183 7.96833C14.6183 7.455 14.21 7.04667 13.7083 7.04667Z"
        fill={color}
      />
    </svg>
  );
}
export function FavoriteIcon({
  width = 25,
  height = 22,
  color = colors.red,
  className = "active-listings-house-card-heard-list-favorite active-listings-house-card-heard-list-opened",
}) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={className}
        d="M18.033 0C15.6511 0 13.6159 1.70992 12.4977 2.88877C11.3795 1.70992 9.34886 0 6.96818 0C2.86477 0 0 2.88076 0 7.00447C0 11.5482 3.55795 14.4851 7 17.3258C8.625 18.6683 10.3068 20.0555 11.5966 21.5937C11.8136 21.8512 12.1318 22 12.4659 22H12.5318C12.867 22 13.1841 21.8501 13.4 21.5937C14.692 20.0555 16.3727 18.6672 17.9989 17.3258C21.4398 14.4862 25 11.5494 25 7.00447C25 2.88076 22.1352 0 18.033 0Z"
        fill={color}
      />
    </svg>
  );
}

export function PossibilityIcon({
  width = 21,
  height = 26,
  color = colors.yellow,
  className = "active-listings-house-card-heard-list-possibility active-listings-house-card-heard-list-opened",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 384 512"
      className={className}
    >
      <path
        fill={color}
        className={className}
        stroke="black"
        strokeWidth="5"
        strokeLinecap="butt"
        d="M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"
      ></path>
    </svg>
  );
}

export function NoteIcon({
  width = 25,
  height = 25,
  color = colors.yellow,
  className = "active-listings-house-card-heard-list-note active-listings-house-card-heard-list-opened",
}) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        className={className}
        fill={color}
        stroke="black"
        strokeWidth="5"
        d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H288V368c0-26.5 21.5-48 48-48H448V96c0-35.3-28.7-64-64-64H64zM448 352H402.7 336c-8.8 0-16 7.2-16 16v66.7V480l32-32 64-64 32-32z"
      />
    </svg>
  );
}

export function DeleteIcon({
  width = 25,
  height = 26,
  color = colors.mainBg,
  className = "active-listings-house-card-heard-list-delete active-listings-house-card-heard-list-opened",
}) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={className}
        d="M23.1844 4.69059C21.2869 4.50202 19.3895 4.3606 17.4802 4.25453V4.24274L17.221 2.71064C17.0442 1.62639 16.7849 0 14.0271 0H10.9393C8.19331 0 7.93403 1.55567 7.74546 2.69886L7.49797 4.20739C6.40193 4.2781 5.30588 4.34881 4.20984 4.45488L1.80562 4.69059C1.31063 4.73773 0.957072 5.17379 1.00421 5.65699C1.05136 6.14019 1.47563 6.49376 1.97062 6.44661L4.37484 6.21091C10.5504 5.59807 16.7731 5.83377 23.0194 6.4584H23.1137C23.5615 6.4584 23.9504 6.11662 23.9976 5.65699C24.0329 5.17379 23.6794 4.73773 23.1844 4.69059Z"
        fill={color}
      />
      <path
        className={className}
        d="M21.0158 8.12015C20.733 7.82552 20.344 7.66052 19.9433 7.66052H5.04666C4.64595 7.66052 4.24525 7.82552 3.97418 8.12015C3.70312 8.41479 3.54991 8.81549 3.57348 9.22798L4.30418 21.3198C4.43381 23.1112 4.59881 25.3504 8.71192 25.3504H16.2781C20.3912 25.3504 20.5563 23.123 20.6858 21.3198L21.4165 9.23977C21.4401 8.81549 21.2869 8.41479 21.0158 8.12015ZM14.4513 19.4459H10.5268C10.0437 19.4459 9.64296 19.0452 9.64296 18.562C9.64296 18.0788 10.0437 17.6781 10.5268 17.6781H14.4513C14.9345 17.6781 15.3353 18.0788 15.3353 18.562C15.3353 19.0452 14.9345 19.4459 14.4513 19.4459ZM15.4413 14.7318H9.54868C9.06548 14.7318 8.66477 14.3311 8.66477 13.8479C8.66477 13.3647 9.06548 12.964 9.54868 12.964H15.4413C15.9245 12.964 16.3252 13.3647 16.3252 13.8479C16.3252 14.3311 15.9245 14.7318 15.4413 14.7318Z"
        fill={color}
      />
    </svg>
  );
}

export function HeardIcon({
  width = 30,
  height = 30,
  color = colors.bodyText,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2721_1477)">
        <g filter="url(#filter0_d_2721_1477)">
          <path
            d="M20.6181 4.4873C18.1996 4.4873 16.1331 6.21115 14.9977 7.39961C13.8623 6.21115 11.8004 4.4873 9.38308 4.4873C5.21654 4.4873 2.30769 7.39154 2.30769 11.5488C2.30769 16.1296 5.92039 19.0904 9.41539 21.9542C11.0654 23.3077 12.7731 24.7062 14.0827 26.2569C14.3031 26.5165 14.6262 26.6665 14.9654 26.6665H15.0323C15.3727 26.6665 15.6946 26.5154 15.9138 26.2569C17.2258 24.7062 18.9323 23.3065 20.5835 21.9542C24.0773 19.0915 27.6923 16.1308 27.6923 11.5488C27.6923 7.39154 24.7835 4.4873 20.6181 4.4873Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_2721_1477"
          x="-2.69231"
          y="3.4873"
          width="35.3846"
          height="32.1792"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2721_1477"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2721_1477"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_2721_1477">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BedIcon({ width = 24, height = 24, color = colors.mainBg }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 7H5V14H3V5H1V20H3V17H21V20H23V11C23 9.93913 22.5786 8.92172 21.8284 8.17157C21.0783 7.42143 20.0609 7 19 7Z"
        fill={color}
      />
    </svg>
  );
}

export function CloseIcon({
  width = 24,
  height = 25,
  strokeWidth = 5,
  color = colors.bodyText,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1728_27722)">
        <path
          d="M19.41 17.9999L27.7 9.70994C27.8638 9.51864 27.9494 9.27256 27.9397 9.02089C27.93 8.76921 27.8256 8.53047 27.6475 8.35238C27.4694 8.17428 27.2307 8.06995 26.979 8.06023C26.7274 8.05051 26.4813 8.13612 26.29 8.29994L18 16.5899L9.70997 8.28994C9.52167 8.10164 9.26627 7.99585 8.99997 7.99585C8.73367 7.99585 8.47828 8.10164 8.28997 8.28994C8.10167 8.47825 7.99588 8.73364 7.99588 8.99994C7.99588 9.26624 8.10167 9.52164 8.28997 9.70994L16.59 17.9999L8.28997 26.2899C8.18529 26.3796 8.10027 26.4899 8.04025 26.614C7.98022 26.738 7.94649 26.8732 7.94117 27.0109C7.93586 27.1486 7.95906 27.2859 8.00934 27.4143C8.05961 27.5426 8.13587 27.6591 8.23332 27.7566C8.33078 27.854 8.44732 27.9303 8.57565 27.9806C8.70398 28.0309 8.84131 28.0541 8.97903 28.0487C9.11675 28.0434 9.25188 28.0097 9.37594 27.9497C9.50001 27.8896 9.61033 27.8046 9.69997 27.6999L18 19.4099L26.29 27.6999C26.4813 27.8638 26.7274 27.9494 26.979 27.9397C27.2307 27.9299 27.4694 27.8256 27.6475 27.6475C27.8256 27.4694 27.93 27.2307 27.9397 26.979C27.9494 26.7273 27.8638 26.4812 27.7 26.2899L19.41 17.9999Z"
          fill={color}
          stroke={color}
          strokeWidth={strokeWidth}
        />
      </g>
      <defs>
        <clipPath id="clip0_1728_27722">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PlusIcon({ width = 19, height = 19, color = colors.mainBg }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 0.75C9.79008 0.75 10.0683 0.865234 10.2734 1.07035C10.4785 1.27547 10.5938 1.55367 10.5938 1.84375V8.40625H17.1562C17.4463 8.40625 17.7245 8.52148 17.9296 8.7266C18.1348 8.93172 18.25 9.20992 18.25 9.5C18.25 9.79008 18.1348 10.0683 17.9296 10.2734C17.7245 10.4785 17.4463 10.5938 17.1562 10.5938H10.5938V17.1562C10.5938 17.4463 10.4785 17.7245 10.2734 17.9296C10.0683 18.1348 9.79008 18.25 9.5 18.25C9.20992 18.25 8.93172 18.1348 8.7266 17.9296C8.52148 17.7245 8.40625 17.4463 8.40625 17.1562V10.5938H1.84375C1.55367 10.5938 1.27547 10.4785 1.07035 10.2734C0.865234 10.0683 0.75 9.79008 0.75 9.5C0.75 9.20992 0.865234 8.93172 1.07035 8.7266C1.27547 8.52148 1.55367 8.40625 1.84375 8.40625H8.40625V1.84375C8.40625 1.55367 8.52148 1.27547 8.7266 1.07035C8.93172 0.865234 9.20992 0.75 9.5 0.75Z"
        fill={color}
      />
    </svg>
  );
}

export function MinusIcon({ width = 19, height = 3, color = colors.mainBg }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2778 0.527771H1.72222C1.46437 0.527771 1.21708 0.630201 1.03476 0.812528C0.85243 0.994855 0.75 1.24214 0.75 1.49999C0.75 1.75784 0.85243 2.00513 1.03476 2.18746C1.21708 2.36979 1.46437 2.47222 1.72222 2.47222H17.2778C17.5356 2.47222 17.7829 2.36979 17.9652 2.18746C18.1476 2.00513 18.25 1.75784 18.25 1.49999C18.25 1.24214 18.1476 0.994855 17.9652 0.812528C17.7829 0.630201 17.5356 0.527771 17.2778 0.527771Z"
        fill={color}
      />
    </svg>
  );
}

export function LevelsIcon({ width = 24, height = 24, color = colors.mainBg }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1728_26917)">
        <path
          d="M2.49398 18.913H6.01398V15.393C6.01398 14.963 6.36398 14.613 6.79498 14.613H10.315V11.093C10.315 10.661 10.665 10.31 11.096 10.31H14.616V6.79101C14.616 6.35901 14.966 6.00901 15.398 6.00901H18.917V2.49001C18.917 2.05801 19.267 1.70801 19.699 1.70801H23.219C23.649 1.70801 24 2.05801 24 2.49001V23.214C24 23.646 23.65 23.996 23.218 23.996H2.49398C2.28658 23.996 2.08767 23.9136 1.94102 23.767C1.79437 23.6203 1.71198 23.4214 1.71198 23.214V19.694C1.71198 19.264 2.06198 18.913 2.49398 18.913ZM0.171979 15.928C0.0619387 15.8179 0.00012207 15.6687 0.00012207 15.513C0.00012207 15.3574 0.0619387 15.2081 0.171979 15.098L15.102 0.16801C15.2127 0.0613014 15.3609 0.00231943 15.5147 0.00374852C15.6685 0.00517761 15.8156 0.0669036 15.9243 0.175651C16.0331 0.284399 16.0948 0.431482 16.0962 0.585269C16.0977 0.739055 16.0387 0.887259 15.932 0.99801L1.00198 15.928C0.771979 16.158 0.401979 16.158 0.171979 15.928Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1728_26917">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BathroomIcon({
  width = 24,
  height = 24,
  color = colors.mainBg,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.487 4.39699C11.1888 4.51244 11.8267 4.87344 12.287 5.41559C12.7472 5.95775 13 6.64579 13 7.35699V9.35699H7V7.35699C7 6.31899 7.528 5.40299 8.33 4.86499C8.04198 4.60853 7.68596 4.44081 7.30482 4.38204C6.92368 4.32326 6.53367 4.37593 6.18178 4.5337C5.82988 4.69148 5.5311 4.94762 5.32143 5.27129C5.11176 5.59496 5.00013 5.97234 5 6.35799V12.358H21C21.2652 12.358 21.5196 12.4633 21.7071 12.6509C21.8946 12.8384 22 13.0928 22 13.358C22 13.6232 21.8946 13.8776 21.7071 14.0651C21.5196 14.2526 21.2652 14.358 21 14.358V15.358C20.9999 16.5989 20.6153 17.8093 19.8989 18.8225C19.1826 19.8358 18.1698 20.6021 17 21.016V21.5C17 21.7652 16.8946 22.0196 16.7071 22.2071C16.5196 22.3946 16.2652 22.5 16 22.5C15.7348 22.5 15.4804 22.3946 15.2929 22.2071C15.1054 22.0196 15 21.7652 15 21.5V21.358H9V21.5C9 21.7652 8.89464 22.0196 8.70711 22.2071C8.51957 22.3946 8.26522 22.5 8 22.5C7.73478 22.5 7.48043 22.3946 7.29289 22.2071C7.10536 22.0196 7 21.7652 7 21.5V21.016C5.83017 20.6021 4.81739 19.8358 4.10106 18.8225C3.38472 17.8093 3.00006 16.5989 3 15.358V14.358C2.73478 14.358 2.48043 14.2526 2.29289 14.0651C2.10536 13.8776 2 13.6232 2 13.358C2 13.0928 2.10536 12.8384 2.29289 12.6509C2.48043 12.4633 2.73478 12.358 3 12.358V6.35799C2.99996 5.47347 3.29309 4.61389 3.83355 3.9137C4.37401 3.2135 5.13131 2.7122 5.98699 2.48819C6.84267 2.26418 7.74846 2.33011 8.56269 2.67567C9.37691 3.02122 10.0536 3.62591 10.487 4.39699Z"
        fill={color}
      />
    </svg>
  );
}

export function LeftArrowIcon({
  width = 22,
  height = 22,
  color = colors.mainBg,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.77097 3.37862C5.68441 3.29116 5.61675 3.18827 5.57183 3.07584C5.52691 2.9634 5.50563 2.84362 5.50919 2.72333C5.51276 2.60304 5.5411 2.4846 5.5926 2.37477C5.6441 2.26494 5.71775 2.16587 5.80935 2.08322C5.90095 2.00057 6.0087 1.93595 6.12644 1.89306C6.24419 1.85017 6.36964 1.82985 6.49561 1.83325C6.62158 1.83666 6.74562 1.86372 6.86065 1.91289C6.97567 1.96207 7.07942 2.0324 7.16598 2.11986L15.3211 10.365C15.4895 10.5351 15.5833 10.7603 15.5833 10.9944C15.5833 11.2285 15.4895 11.4537 15.3211 11.6238L7.16598 19.8699C7.07999 19.9592 6.97626 20.0314 6.86082 20.0822C6.74537 20.133 6.62051 20.1613 6.49349 20.1656C6.36647 20.17 6.23981 20.1501 6.12089 20.1073C6.00196 20.0645 5.89313 19.9995 5.80072 19.9162C5.7083 19.8329 5.63415 19.7328 5.58257 19.6219C5.53098 19.511 5.50299 19.3914 5.50023 19.27C5.49746 19.1487 5.51997 19.028 5.56645 18.9151C5.61293 18.8021 5.68245 18.6991 5.77097 18.612L13.3044 10.9944L5.77097 3.37862Z"
        fill={color}
      />
    </svg>
  );
}

export function RightArrowIcon({
  width = 22,
  height = 22,
  color = colors.mainBg,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.229 18.6214C16.3156 18.7088 16.3833 18.8117 16.4282 18.9242C16.4731 19.0366 16.4944 19.1564 16.4908 19.2767C16.4872 19.397 16.4589 19.5154 16.4074 19.6252C16.3559 19.7351 16.2822 19.8341 16.1907 19.9168C16.0991 19.9994 15.9913 20.064 15.8736 20.1069C15.7558 20.1498 15.6304 20.1702 15.5044 20.1667C15.3784 20.1633 15.2544 20.1363 15.1394 20.0871C15.0243 20.0379 14.9206 19.9676 14.834 19.8801L6.67892 11.635C6.51051 11.4649 6.41667 11.2397 6.41667 11.0056C6.41667 10.7715 6.51051 10.5463 6.67892 10.3762L14.834 2.13014C14.92 2.04076 15.0237 1.96858 15.1392 1.91781C15.2546 1.86703 15.3795 1.83867 15.5065 1.83436C15.6335 1.83005 15.7602 1.84988 15.8791 1.89271C15.998 1.93553 16.1069 2.00049 16.1993 2.08382C16.2917 2.16714 16.3658 2.26717 16.4174 2.3781C16.469 2.48902 16.497 2.60862 16.4998 2.72996C16.5025 2.8513 16.48 2.97195 16.4336 3.08492C16.3871 3.19788 16.3176 3.30089 16.229 3.38798L8.69563 11.0056L16.229 18.6214Z"
        fill={color}
      />
    </svg>
  );
}

export function RightArrowIconCircle({
  width = 22,
  height = 22,
  color = colors.mainBg,
  className,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 512 512"
    >
      <path
        stroke="black"
        strokeWidth="10"
        fill={color}
        d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"
      />
    </svg>
  );
}

export function LeftArrowIconCircle({
  width = 22,
  height = 22,
  color = colors.mainBg,
  className,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 512 512"
    >
      <path
        stroke="black"
        strokeWidth="10"
        fill={color}
        d="M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"
      />
    </svg>
  );
}

export function MatkerIcon({ width = 52, height = 52, color = colors.blue }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26 3.25C21.261 3.25559 16.7177 5.14064 13.3667 8.49164C10.0157 11.8426 8.13061 16.386 8.12502 21.125C8.11934 24.9977 9.38436 28.7654 11.726 31.85C11.726 31.85 12.2135 32.4919 12.2931 32.5845L26 48.75L39.7134 32.5764C39.7849 32.4903 40.274 31.85 40.274 31.85L40.2756 31.8451C42.6161 28.7619 43.8806 24.996 43.875 21.125C43.8694 16.386 41.9844 11.8426 38.6334 8.49164C35.2824 5.14064 30.739 3.25559 26 3.25ZM26 27.625C24.7144 27.625 23.4577 27.2438 22.3888 26.5296C21.3199 25.8153 20.4868 24.8002 19.9948 23.6124C19.5028 22.4247 19.3741 21.1178 19.6249 19.8569C19.8757 18.596 20.4948 17.4378 21.4038 16.5288C22.3129 15.6198 23.4711 15.0007 24.7319 14.7499C25.9928 14.4991 27.2997 14.6278 28.4875 15.1198C29.6752 15.6118 30.6903 16.4449 31.4046 17.5138C32.1188 18.5827 32.5 19.8394 32.5 21.125C32.4979 22.8482 31.8124 24.5003 30.5938 25.7188C29.3753 26.9373 27.7233 27.6229 26 27.625Z"
        fill={color}
      />
    </svg>
  );
}

export function CubeIcon({ width = 27, height = 24, color = colors.blue }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.21875 11.8125C3.99497 11.8125 3.78036 11.7236 3.62213 11.5654C3.4639 11.4072 3.375 11.1925 3.375 10.9688V4.22046C3.375 3.99668 3.4639 3.78207 3.62213 3.62384C3.78036 3.4656 3.99497 3.37671 4.21875 3.37671H10.9688C11.1925 3.37671 11.4071 3.4656 11.5654 3.62384C11.7236 3.78207 11.8125 3.99668 11.8125 4.22046V10.9688C11.8125 11.1925 11.7236 11.4072 11.5654 11.5654C11.4071 11.7236 11.1925 11.8125 10.9688 11.8125H4.21875ZM16.0312 11.8125C15.8075 11.8125 15.5929 11.7236 15.4346 11.5654C15.2764 11.4072 15.1875 11.1925 15.1875 10.9688V4.22046C15.1875 3.99668 15.2764 3.78207 15.4346 3.62384C15.5929 3.4656 15.8075 3.37671 16.0312 3.37671H22.7796C23.0033 3.37671 23.218 3.4656 23.3762 3.62384C23.5344 3.78207 23.6233 3.99668 23.6233 4.22046V10.9688C23.6233 11.1925 23.5344 11.4072 23.3762 11.5654C23.218 11.7236 23.0033 11.8125 22.7796 11.8125H16.0312ZM4.21875 23.625C3.99497 23.625 3.78036 23.5361 3.62213 23.3779C3.4639 23.2197 3.375 23.005 3.375 22.7813V16.0313C3.375 15.8075 3.4639 15.5929 3.62213 15.4346C3.78036 15.2764 3.99497 15.1875 4.21875 15.1875H10.9688C11.1925 15.1875 11.4071 15.2764 11.5654 15.4346C11.7236 15.5929 11.8125 15.8075 11.8125 16.0313V22.7813C11.8125 23.005 11.7236 23.2197 11.5654 23.3779C11.4071 23.5361 11.1925 23.625 10.9688 23.625H4.21875ZM16.0312 23.625C15.8075 23.625 15.5929 23.5361 15.4346 23.3779C15.2764 23.2197 15.1875 23.005 15.1875 22.7813V16.0313C15.1875 15.8075 15.2764 15.5929 15.4346 15.4346C15.5929 15.2764 15.8075 15.1875 16.0312 15.1875H22.7796C23.0033 15.1875 23.218 15.2764 23.3762 15.4346C23.5344 15.5929 23.6233 15.8075 23.6233 16.0313V22.7813C23.6233 23.005 23.5344 23.2197 23.3762 23.3779C23.218 23.5361 23.0033 23.625 22.7796 23.625H16.0312Z"
        fill={color}
      />
    </svg>
  );
}

export function ListIcon({ width = 40, height = 41, color = colors.mainBg }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66667 22.1666C7.58333 22.1666 8.33333 21.4166 8.33333 20.5C8.33333 19.5833 7.58333 18.8333 6.66667 18.8333C5.75 18.8333 5 19.5833 5 20.5C5 21.4166 5.75 22.1666 6.66667 22.1666ZM6.66667 28.8333C7.58333 28.8333 8.33333 28.0833 8.33333 27.1666C8.33333 26.25 7.58333 25.5 6.66667 25.5C5.75 25.5 5 26.25 5 27.1666C5 28.0833 5.75 28.8333 6.66667 28.8333ZM6.66667 15.5C7.58333 15.5 8.33333 14.75 8.33333 13.8333C8.33333 12.9166 7.58333 12.1666 6.66667 12.1666C5.75 12.1666 5 12.9166 5 13.8333C5 14.75 5.75 15.5 6.66667 15.5ZM13.3333 22.1666H33.3333C34.25 22.1666 35 21.4166 35 20.5C35 19.5833 34.25 18.8333 33.3333 18.8333H13.3333C12.4167 18.8333 11.6667 19.5833 11.6667 20.5C11.6667 21.4166 12.4167 22.1666 13.3333 22.1666ZM13.3333 28.8333H33.3333C34.25 28.8333 35 28.0833 35 27.1666C35 26.25 34.25 25.5 33.3333 25.5H13.3333C12.4167 25.5 11.6667 26.25 11.6667 27.1666C11.6667 28.0833 12.4167 28.8333 13.3333 28.8333ZM11.6667 13.8333C11.6667 14.75 12.4167 15.5 13.3333 15.5H33.3333C34.25 15.5 35 14.75 35 13.8333C35 12.9166 34.25 12.1666 33.3333 12.1666H13.3333C12.4167 12.1666 11.6667 12.9166 11.6667 13.8333ZM6.66667 22.1666C7.58333 22.1666 8.33333 21.4166 8.33333 20.5C8.33333 19.5833 7.58333 18.8333 6.66667 18.8333C5.75 18.8333 5 19.5833 5 20.5C5 21.4166 5.75 22.1666 6.66667 22.1666ZM6.66667 28.8333C7.58333 28.8333 8.33333 28.0833 8.33333 27.1666C8.33333 26.25 7.58333 25.5 6.66667 25.5C5.75 25.5 5 26.25 5 27.1666C5 28.0833 5.75 28.8333 6.66667 28.8333ZM6.66667 15.5C7.58333 15.5 8.33333 14.75 8.33333 13.8333C8.33333 12.9166 7.58333 12.1666 6.66667 12.1666C5.75 12.1666 5 12.9166 5 13.8333C5 14.75 5.75 15.5 6.66667 15.5ZM13.3333 22.1666H33.3333C34.25 22.1666 35 21.4166 35 20.5C35 19.5833 34.25 18.8333 33.3333 18.8333H13.3333C12.4167 18.8333 11.6667 19.5833 11.6667 20.5C11.6667 21.4166 12.4167 22.1666 13.3333 22.1666ZM13.3333 28.8333H33.3333C34.25 28.8333 35 28.0833 35 27.1666C35 26.25 34.25 25.5 33.3333 25.5H13.3333C12.4167 25.5 11.6667 26.25 11.6667 27.1666C11.6667 28.0833 12.4167 28.8333 13.3333 28.8333ZM11.6667 13.8333C11.6667 14.75 12.4167 15.5 13.3333 15.5H33.3333C34.25 15.5 35 14.75 35 13.8333C35 12.9166 34.25 12.1666 33.3333 12.1666H13.3333C12.4167 12.1666 11.6667 12.9166 11.6667 13.8333Z"
        fill={color}
      />
    </svg>
  );
}

export function CheckBoxIcon({
  width = 28,
  height = 28,
  color = colors.mainBg,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 7.875C3.5 6.71468 3.96094 5.60188 4.78141 4.78141C5.60188 3.96094 6.71468 3.5 7.875 3.5H20.125C21.2853 3.5 22.3981 3.96094 23.2186 4.78141C24.0391 5.60188 24.5 6.71468 24.5 7.875V20.125C24.5 21.2853 24.0391 22.3981 23.2186 23.2186C22.3981 24.0391 21.2853 24.5 20.125 24.5H7.875C6.71468 24.5 5.60188 24.0391 4.78141 23.2186C3.96094 22.3981 3.5 21.2853 3.5 20.125V7.875ZM7.875 5.25C7.17881 5.25 6.51113 5.52656 6.01884 6.01884C5.52656 6.51113 5.25 7.17881 5.25 7.875V20.125C5.25 20.8212 5.52656 21.4889 6.01884 21.9812C6.51113 22.4734 7.17881 22.75 7.875 22.75H20.125C20.8212 22.75 21.4889 22.4734 21.9812 21.9812C22.4734 21.4889 22.75 20.8212 22.75 20.125V7.875C22.75 7.17881 22.4734 6.51113 21.9812 6.01884C21.4889 5.52656 20.8212 5.25 20.125 5.25H7.875Z"
        fill={color}
      />
    </svg>
  );
}

export function CheckBoxActiveIcon({
  width = 28,
  height = 28,
  color = colors.blue,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.54199 3.5C7.38167 3.5 6.26887 3.96094 5.4484 4.78141C4.62793 5.60188 4.16699 6.71468 4.16699 7.875V20.125C4.16699 21.2853 4.62793 22.3981 5.4484 23.2186C6.26887 24.0391 7.38167 24.5 8.54199 24.5H20.792C21.9523 24.5 23.0651 24.0391 23.8856 23.2186C24.7061 22.3981 25.167 21.2853 25.167 20.125V7.875C25.167 6.71468 24.7061 5.60188 23.8856 4.78141C23.0651 3.96094 21.9523 3.5 20.792 3.5H8.54199ZM5.91699 7.875C5.91699 7.17881 6.19355 6.51113 6.68584 6.01884C7.17812 5.52656 7.8458 5.25 8.54199 5.25H20.792C21.4882 5.25 22.1559 5.52656 22.6481 6.01884C23.1404 6.51113 23.417 7.17881 23.417 7.875V20.125C23.417 20.8212 23.1404 21.4889 22.6481 21.9812C22.1559 22.4734 21.4882 22.75 20.792 22.75H8.54199C7.8458 22.75 7.17812 22.4734 6.68584 21.9812C6.19355 21.4889 5.91699 20.8212 5.91699 20.125V7.875ZM19.6615 11.9945C19.8258 11.8302 19.9181 11.6074 19.9181 11.375C19.9181 11.1426 19.8258 10.9198 19.6615 10.7555C19.4972 10.5912 19.2744 10.4989 19.042 10.4989C18.8096 10.4989 18.5868 10.5912 18.4225 10.7555L12.917 16.2628L10.9115 14.2555C10.7472 14.0912 10.5243 13.9989 10.292 13.9989C10.0596 13.9989 9.83679 14.0912 9.67249 14.2555C9.50819 14.4198 9.41589 14.6426 9.41589 14.875C9.41589 15.1074 9.50819 15.3302 9.67249 15.4945L12.2975 18.1195C12.3788 18.201 12.4753 18.2656 12.5816 18.3097C12.6879 18.3539 12.8019 18.3766 12.917 18.3766C13.0321 18.3766 13.146 18.3539 13.2524 18.3097C13.3587 18.2656 13.4552 18.201 13.5365 18.1195L19.6615 11.9945Z"
        fill={color}
      />
    </svg>
  );
}

export function FiltersIcon({
  width = 24,
  height = 25,
  color = colors.mainBg,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.73612 17.089L14.5616 17.1068C14.9249 17.1081 15.2189 17.4122 15.2189 17.7851V21.0624C15.2189 21.4366 15.0064 21.7751 14.6753 21.9317L9.38724 24.4147C9.26369 24.472 9.13273 24.5 9.00176 24.5C8.82755 24.5 8.65334 24.4491 8.50138 24.3485C8.23574 24.1729 8.07512 23.87 8.07512 23.5455V17.7673C8.07512 17.3919 8.37164 17.0877 8.73612 17.089ZM21.4462 0.5C22.8571 0.5 24 1.67726 24 3.13071V4.96851C24 5.67359 23.7245 6.35068 23.2352 6.84449L15.4292 14.7404C15.2945 14.8779 15.1117 14.9542 14.9226 14.953L8.38672 14.9326C8.1878 14.9326 7.99876 14.8473 7.86286 14.6984L0.689421 6.80886C0.245869 6.32141 0 5.67741 0 5.00924V3.13198C0 1.67854 1.14286 0.5 2.55382 0.5H21.4462Z"
        fill={color}
      />
    </svg>
  );
}

export const DefaultAvatarIcon = (color = colors.bodyText) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M725.333333 640a213.333333 213.333333 0 0 1 213.333334 213.333333v85.333334H85.333333v-85.333334a213.333333 213.333333 0 0 1 209.237334-213.333333A318.592 318.592 0 0 0 512 725.333333a318.848 318.848 0 0 0 217.429333-85.205333L725.333333 640zM512 85.333333a277.333333 277.333333 0 1 1 0 554.666667 277.333333 277.333333 0 0 1 0-554.666667z"
        fill="#000000"
      />
    </svg>
  );
};

export function SMSIcon({ width = 24, height = 25, color = colors.mainBg }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 512 512"
    >
      <path
        fill={color}
        d="M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM202.9 176.8c6.5-2.2 13.7 .1 17.9 5.6L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2zm173.1 38c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.2-.4-23.7-4.4-32.6-7.4l0 0 0 0c-1.4-.5-2.7-.9-4-1.4c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7 .6 3.3 1.1 4.9 1.6l0 0 0 0c9.1 3.1 15.6 5.3 22.6 5.5c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6c-9-5.4-17.7-14.7-17.7-29.4c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c10 .2 19.7 2.3 27.9 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9zm-272 0c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.3-.4-24.2-4.5-33.2-7.6l0 0 0 0c-1.3-.4-2.5-.8-3.6-1.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4 .5 2.8 .9 4.1 1.4l0 0 0 0c9.5 3.2 16.5 5.6 23.7 5.8c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4 0 0c-7.2-2.2-16.7-5-24.3-9.6C80.8 239 72.1 229.7 72 215c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c9.5 .1 22.2 2.1 31.1 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9z"
      />
    </svg>
  );
}

export function WhatsappIcon({
  width = 24,
  height = 25,
  color = colors.mainBg,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 448 512"
    >
      <path
        fill={color}
        d="M224 122.8c-72.7 0-131.8 59.1-131.9 131.8 0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6 49.9-13.1 4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8 0-35.2-15.2-68.3-40.1-93.2-25-25-58-38.7-93.2-38.7zm77.5 188.4c-3.3 9.3-19.1 17.7-26.7 18.8-12.6 1.9-22.4.9-47.5-9.9-39.7-17.2-65.7-57.2-67.7-59.8-2-2.6-16.2-21.5-16.2-41s10.2-29.1 13.9-33.1c3.6-4 7.9-5 10.6-5 2.6 0 5.3 0 7.6.1 2.4.1 5.7-.9 8.9 6.8 3.3 7.9 11.2 27.4 12.2 29.4s1.7 4.3.3 6.9c-7.6 15.2-15.7 14.6-11.6 21.6 15.3 26.3 30.6 35.4 53.9 47.1 4 2 6.3 1.7 8.6-1 2.3-2.6 9.9-11.6 12.5-15.5 2.6-4 5.3-3.3 8.9-2 3.6 1.3 23.1 10.9 27.1 12.9s6.6 3 7.6 4.6c.9 1.9.9 9.9-2.4 19.1zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM223.9 413.2c-26.6 0-52.7-6.7-75.8-19.3L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5 29.9 30 47.9 69.8 47.9 112.2 0 87.4-72.7 158.5-160.1 158.5z"
      />
    </svg>
  );
}

export function EmailIcon({ width = 24, height = 25, color = colors.mainBg }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 512 512"
    >
      <path
        fill={color}
        d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
      />
    </svg>
  );
}

export function ShareIcon({
  width = 24,
  height = 25,
  color = colors.mainBg,
  stroke = "none",
  strokeWidth = "0",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 576 512"
    >
      <path
        fill={color}
        stroke={stroke}
        strokeWidth={strokeWidth}
        filter={"url(#drop-shadow)"}
        d="M352 224H305.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32V224zM80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V384c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z"
      />
      <defs>
        <filter id="drop-shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow
            dx="2"
            dy="2"
            stdDeviation="4"
            floodColor="black"
            floodOpacity="0.5"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function BoltIcon({ width = 24, height = 25, color = colors.mainBg }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 448 512"
    >
      <path
        fill={color}
        d="M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"
      />
    </svg>
  );
}

export function ImagesIcon({ width = 24, height = 25, color = colors.mainBg }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 576 512"
    >
      <path
        fill={color}
        d="M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H328 280 200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
      />
    </svg>
  );
}

export function RulerCombined({
  width = 18,
  height = 18,
  color = colors.mainBg,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 512 512"
    >
      <path
        fill={color}
        d="M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"
      />
    </svg>
  );
}

export function VerifiedIcon({
  width = 27,
  height = 19,
  strokeWidth = 0,
  color = colors.mainBg,
}) {
  return (
    <svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 734.64 697.92"
      width={width}
      height={height}
    >
      <g>
        <path
          strokeWidth={strokeWidth}
          fill={color}
          d="m626.26,255.21c9.98,29.44,15.39,60.97,15.39,93.74,0,161.39-131.3,292.7-292.7,292.7S56.26,510.35,56.26,348.96,187.56,56.26,348.96,56.26c54.57,0,105.69,15.03,149.47,41.14,13.88-13.73,28.28-27.03,43.12-39.56C484.92,20.21,418.5,0,348.96,0c-93.21,0-180.84,36.3-246.75,102.21C36.3,168.12,0,255.75,0,348.96s36.3,180.84,102.21,246.75c65.91,65.91,153.54,102.21,246.75,102.21s180.84-36.3,246.75-102.21c65.91-65.91,102.21-153.54,102.21-246.75,0-48.38-9.8-95.25-28.42-138.36-13.64,13.07-28.17,27.85-43.23,44.62Z"
        ></path>
        <path
          strokeWidth={strokeWidth}
          fill={color}
          d="m122.42,283.71s54.54-56.16,108.67-44.1c54.14,12.05,93.44,72.58,127.23,133.55,0,0,115.64-203.66,259.17-302.81,0,0,53.08-35.93,105.29-21.18,10.41,2.94,15.1,14.91,9.4,24.11-5.91,9.53-18,23.37-41.53,43.27-62.98,53.27-171.37,146.8-260.29,337.25,0,0-43.64,89.55-120.36,86.47-1.06-.04-2.12-.09-3.18-.12-5.18-.17-30.3-2.75-35.17-36.79-5.44-37.99-37.43-152.17-149.23-219.64Z"
        ></path>
      </g>
    </svg>
  );
}

export function TwoComasIcon({ width = 32, height = 24, color = colors.gray }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 27 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 11.5742C2.77344 11.2487 1.99219 10.6953 1.40625 9.91406C0.820312 9.06771 0.494792 8.15625 0.429688 7.17969C0.429688 6.20312 0.690104 5.25911 1.21094 4.34766C1.79688 3.37109 2.67578 2.55729 3.84766 1.90625C5.73568 0.864583 7.36328 0.604167 8.73047 1.125C10.1628 1.64583 11.2044 2.42708 11.8555 3.46875C12.181 3.98958 12.4089 4.70573 12.5391 5.61719C12.7344 6.46354 12.7995 7.40755 12.7344 8.44922C12.7344 9.42578 12.6367 10.4023 12.4414 11.3789C12.2461 12.3555 11.9531 13.1693 11.5625 13.8203C11.237 14.3411 10.8464 14.862 10.3906 15.3828C10 15.8385 9.51172 16.2943 8.92578 16.75C8.40495 17.2057 7.78646 17.6289 7.07031 18.0195L3.55469 17.7266C4.01042 17.2057 4.43359 16.75 4.82422 16.3594C5.21484 15.9036 5.54036 15.513 5.80078 15.1875C6.0612 14.862 6.32161 14.569 6.58203 14.3086C6.97266 13.8529 7.29818 13.3971 7.55859 12.9414C7.81901 12.5508 8.04688 12.1602 8.24219 11.7695C8.4375 11.3138 8.47005 10.8581 8.33984 10.4023C7.81901 10.9232 7.29818 11.2812 6.77734 11.4766C6.25651 11.6719 5.76823 11.7695 5.3125 11.7695C4.79167 11.8346 4.27083 11.7695 3.75 11.5742ZM17.2266 10.9883C16.3151 10.5326 15.6315 9.88151 15.1758 9.03516C14.7852 8.1237 14.6549 7.17969 14.7852 6.20312C14.9154 5.22656 15.306 4.3151 15.957 3.46875C16.6081 2.6224 17.5846 1.97135 18.8867 1.51562C20.9049 0.799479 22.5651 0.832031 23.8672 1.61328C25.1693 2.39453 26.0807 3.33854 26.6016 4.44531C26.7969 5.03125 26.8945 5.77995 26.8945 6.69141C26.8945 7.60286 26.7969 8.54688 26.6016 9.52344C26.4062 10.5 26.1133 11.444 25.7227 12.3555C25.3971 13.2669 25.0065 14.0156 24.5508 14.6016C24.1602 15.0573 23.7044 15.4805 23.1836 15.8711C22.7279 16.1966 22.1745 16.5547 21.5234 16.9453C20.9375 17.3359 20.2539 17.6615 19.4727 17.9219L16.0547 17.1406C16.5755 16.6849 17.0312 16.2943 17.4219 15.9688C17.8776 15.5781 18.2682 15.2526 18.5938 14.9922C18.9193 14.7318 19.2448 14.5039 19.5703 14.3086C20.026 13.918 20.4167 13.5273 20.7422 13.1367C21.0677 12.8112 21.3281 12.4531 21.5234 12.0625C21.7839 11.6068 21.9141 11.1185 21.9141 10.5977C21.3932 11.0534 20.8398 11.3464 20.2539 11.4766C19.7331 11.5417 19.2448 11.5417 18.7891 11.4766C18.2682 11.4115 17.7474 11.2487 17.2266 10.9883Z"
        fill={color}
      ></path>
    </svg>
  );
}

export function StarIcon({
  width = 12,
  height = 12,
  color = colors.blue,
  full = true,
}) {
  return (
    <svg
      height={height}
      width={width}
      version="1.1"
      id="Capa_1"
      viewBox="0 0 47.94 47.94"
      transform="rotate(360)"
      stroke="black"
      fill={full ? "#000000" : "black"}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="1"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill={full ? color : "transparent"}
          d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757 c2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042 c0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685 c-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528 c-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956 C22.602,0.567,25.338,0.567,26.285,2.486z"
        ></path>
      </g>
    </svg>
  );
}

export function InfoIcon({
  width = "16px",
  height = "16px",
  color = colors.blue,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={width}
      height={height}
    >
      <path
        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        fill={color}
      ></path>
    </svg>
  );
}
